import { QueryDtoOf } from '@40seas/entities/common';
import { Funds } from '../funds.entity';

export class QueryFundsDto extends QueryDtoOf(Funds) {}
